import { render, staticRenderFns } from "./PaginationLinks.vue?vue&type=template&id=55e1d443"
import script from "./PaginationLinks.vue?vue&type=script&lang=ts"
export * from "./PaginationLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports